import React, { useEffect, useState } from 'react';
import Icon from '../../Icon';
import { translate } from '../../../Services/translation';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';

const CheckoutScreenConfirmation = () => {
  const checkout = useTypedSelector((state) => state.checkout);
  const { payload } = checkout;
  const { redirectUrl } = payload;

  const [secondsLeft, setSecondsLeft] = useState<number>(5);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (redirectUrl) {
        location.href = redirectUrl;
      }
    }, 5000);

    const interval = setInterval(() => {
      setSecondsLeft((prevSeconds) => prevSeconds - 1);
      if (secondsLeft <= 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="flex h-[calc(100vh-175px)] flex-col items-center justify-center gap-3">
      <h1>{translate('checkout.order-success')}</h1>
      <Icon name="check-mark" className="h-20 w-20" />
      <h3>
        {translate('checkout.order-redirect').replace(
          '{0}',
          secondsLeft.toString()
        )}
      </h3>
    </div>
  );
};

export default CheckoutScreenConfirmation;
